import { VORGANG_ARTEN } from "../../../data/vorgangArt";

/**
 * Reine Ableitungen für den Übersichtskarten-Kopf (SP4). Bewusst als
 * DOM-freies `.ts`-Modul, damit der (node-only) Vitest-Runner sie prüft.
 */

/**
 * Eyebrow-Zeile über dem Betreff (Review B3): „Vorgang: <Art>".
 *
 * Seit PO 02.08.2026 steht die Art im Chip NEBEN dem Betreff — der Kopf ruft
 * die Funktion deshalb ohne Art auf („Vorgang"). Sie bleibt für Aufrufer mit
 * Art-Suffix erhalten (Fenster-Titel, Verweise).
 */
export function eyebrowLabel(art?: string | null): string {
    const a = (art ?? "").trim();
    return a ? `Vorgang: ${a}` : "Vorgang";
}

/**
 * Optionen des Art-Dropdowns auf der Detailseite: die bekannten Arten
 * (inkl. „Sonstige") plus eine evtl. abweichende Bestands-Art des Vorgangs
 * (Freitext), damit ein bereits gesetzter Wert nicht aus der Liste fällt.
 */
/**
 * Anzeige-Kennung eines Vorgangs: die fachliche Nummer, wenn es sie gibt, sonst
 * die technische Id (PO 26.07.2026, Punkt 4). Bestandsvorgänge ohne auflösbaren
 * Kunden haben keine Nummer — dort ist die Id besser als gar nichts.
 */
export function vorgangKennung(vorgangNbr?: string | null, id?: number | null): string {
    const nbr = (vorgangNbr ?? "").trim();
    if (nbr) return nbr;
    return id != null ? `#${id}` : "";
}

export function artOptions(current?: string | null): string[] {
    const base: string[] = [...VORGANG_ARTEN];
    const c = (current ?? "").trim();
    if (c && !base.includes(c)) base.unshift(c);
    return base;
}

/**
 * Status-Darstellung der Übersichtskarte (Review F1/F2): OHNE aktive To-dos ist
 * der Vorgang direkt erledigbar (Erledigt-Haken); MIT To-dos zeigt die Karte
 * den serverseitig abgeleiteten Status read-only (kein „Offen"-Badge-Klick).
 */
export function statusMode(
    fortschrittGesamt?: number | null,
): "erledigt-toggle" | "derived-badge" {
    return (fortschrittGesamt ?? 0) > 0 ? "derived-badge" : "erledigt-toggle";
}

/** Ziel-Status beim Klick auf den Erledigt-Haken (Rück-Klick öffnet wieder). */
export function toggledManualStatus(done: boolean): "Offen" | "Erledigt" {
    return done ? "Offen" : "Erledigt";
}
